// apps/web/src/api/road-options.ts — typed wrappers around
// `/api/road-options/*` (#995 backend, #1152 admin surface).
// Mirrors the arrival-cities CRUD contract.

import {
  GetRoadOptionsResponseSchema,
  RoadOptionSchema,
  type CreateRoadOptionInput,
  type GetRoadOptionsQuery,
  type GetRoadOptionsResponse,
  type PatchRoadOptionInput,
  type RoadOption,
} from '@magimp/shared';
import { request } from './client.js';

function withQuery(path: string, qs: string): string {
  return qs.length > 0 ? `${path}?${qs}` : path;
}

export function listRoadOptions(
  query: Partial<GetRoadOptionsQuery> = {},
): Promise<GetRoadOptionsResponse> {
  const params = new URLSearchParams();
  if (query.q) params.set('q', query.q);
  if (query.active !== undefined) params.set('active', String(query.active));
  if (query.cursor) params.set('cursor', query.cursor);
  if (query.limit !== undefined) params.set('limit', String(query.limit));
  return request<GetRoadOptionsResponse>(
    withQuery('/road-options', params.toString()),
    { method: 'GET' },
    {},
    GetRoadOptionsResponseSchema,
  );
}

export function fetchRoadOption(id: string): Promise<RoadOption> {
  return request<RoadOption>(
    `/road-options/${encodeURIComponent(id)}`,
    { method: 'GET' },
    {},
    RoadOptionSchema,
  );
}

export function createRoadOption(body: CreateRoadOptionInput): Promise<RoadOption> {
  return request<RoadOption>(
    '/road-options',
    {
      method: 'POST',
      body: JSON.stringify(body),
      headers: { 'content-type': 'application/json' },
    },
    {},
    RoadOptionSchema,
  );
}

export function patchRoadOption(id: string, body: PatchRoadOptionInput): Promise<RoadOption> {
  return request<RoadOption>(
    `/road-options/${encodeURIComponent(id)}`,
    {
      method: 'PATCH',
      body: JSON.stringify(body),
      headers: { 'content-type': 'application/json' },
    },
    {},
    RoadOptionSchema,
  );
}

export function archiveRoadOption(id: string): Promise<RoadOption> {
  return request<RoadOption>(
    `/road-options/${encodeURIComponent(id)}`,
    { method: 'DELETE' },
    {},
    RoadOptionSchema,
  );
}

export function activateRoadOption(id: string): Promise<RoadOption> {
  return request<RoadOption>(
    `/road-options/${encodeURIComponent(id)}/activate`,
    { method: 'POST' },
    {},
    RoadOptionSchema,
  );
}
